(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/personal-results/personal-results.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/personal-results/personal-results.js');
"use strict";

var _svs$core$session;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCompetitionId = svs.components.marketplaceCompetition.competitionContext.useCompetitionId;
const useTeamsIds = svs.components.marketplaceCompetition.services.hooks.useTeamsIds;
const _svs$components$marke = svs.components.marketplaceCompetition.services.hooks,
  usePersonalResults = _svs$components$marke.usePersonalResults,
  usePlayerCompetitions = _svs$components$marke.usePlayerCompetitions;
const FetchState = svs.components.marketplaceCompetition.constants.FetchState;
const _svs$components$marke2 = svs.components.marketplaceCompetition.routeResult.personalResults,
  PersonalResultsIndividual = _svs$components$marke2.PersonalResultsIndividual,
  PersonalResultsTeam = _svs$components$marke2.PersonalResultsTeam;
const _svs$core$session$dat = (_svs$core$session = svs.core.session) === null || _svs$core$session === void 0 || (_svs$core$session = _svs$core$session.data) === null || _svs$core$session === void 0 ? void 0 : _svs$core$session.userSession,
  firstName = _svs$core$session$dat.firstName,
  lastName = _svs$core$session$dat.lastName;
const selectPlayerCompetitionsStatus = svs.components.marketplaceCompetition.services.selectors.playerCompetitionSelectors.selectPlayerCompetitionsStatus;
const RejectedPlayer = svs.components.marketplaceCompetition.common.RejectedPlayer;
const ReactPaper = svs.ui.ReactPaper;
const CompetitionSubscriberManager = svs.components.marketplaceCompetition.services.components.CompetitionSubscriberManager;
const sortByTeamName = (a, b) => {
  if (a.teamName > b.teamName) {
    return 1;
  }
  if (b.teamName > a.teamName) {
    return -1;
  }
  return 0;
};
const sortByPlacement = (a, b) => {
  if (a.position.current > b.position.current) {
    return 1;
  }
  if (b.position.current > a.position.current) {
    return -1;
  }
  return sortByTeamName(a, b);
};
const sortTeams = (a, b) => {
  if (a.status === FetchState.Pending && b.status === FetchState.Pending) {
    return 0;
  } else if (a.status !== FetchState.Pending && b.status === FetchState.Pending) {
    return 1;
  } else if (a.status === FetchState.Pending && b.status !== FetchState.Pending) {
    return -1;
  }
  return sortByPlacement(a.data, b.data);
};
const PersonalResults = _ref => {
  let _ref$showIndividual = _ref.showIndividual,
    showIndividual = _ref$showIndividual === void 0 ? true : _ref$showIndividual,
    _ref$showTeams = _ref.showTeams,
    showTeams = _ref$showTeams === void 0 ? true : _ref$showTeams;
  const competitionId = useCompetitionId();
  const playerCompetitions = usePlayerCompetitions();
  const _useSelector = useSelector(selectPlayerCompetitionsStatus),
    _useSelector2 = _slicedToArray(_useSelector, 1),
    status = _useSelector2[0];
  const personalTeams = useTeamsIds(competitionId);
  const personalResult = usePersonalResults(competitionId, personalTeams);
  const isUserRegisteredInCompetition = competitionId && (playerCompetitions === null || playerCompetitions === void 0 ? void 0 : playerCompetitions[competitionId]);
  const _ref2 = personalResult ? personalResult : {},
    individual = _ref2.individual,
    teams = _ref2.teams;
  const teamsArr = useMemo(() => {
    if (!teams) {
      return [];
    }
    return Object.values(teams).sort(sortTeams);
  }, [teams]);
  if (status === FetchState.Rejected) {
    return React.createElement(RejectedPlayer, {
      activeOnly: true,
      InnerComponent: ReactPaper,
      text: "F\xF6r tillf\xE4llet g\xE5r det inte att visa n\xE5gon personlig information om t\xE4vlingen."
    });
  }
  if (!isUserRegisteredInCompetition || !individual && !teams) {
    return null;
  }
  return React.createElement("div", {
    className: "personal-result-container data-hj-suppress"
  }, React.createElement(CompetitionSubscriberManager, {
    competitionId: competitionId
  }), showIndividual && React.createElement(PersonalResultsIndividual, {
    firstname: firstName,
    individual: individual,
    lastname: lastName
  }), showTeams && teamsArr && teamsArr.map(t => React.createElement(PersonalResultsTeam, {
    key: t.data.id,
    team: t
  })));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.personalResults.PersonalResults', PersonalResults);

 })(window);